import { createAtomWithStorage } from '@/uiStates/utils';

export enum ProjectsFilterOptions {
  All = 'all',
  OwnedByMe = 'owned_by_me',
  SharedWithMe = 'shared_with_me',
}

export enum ProjectsViewMode {
  Grid = 'grid',
  List = 'list',
}

export enum SearchScope {
  CurrentFolder = 'current_folder',
  AllFolders = 'all_folders',
}

export enum ItemType {
  IncludeFolders = 'include_folders',
  ProjectsOnly = 'projects_only',
}

export const viewModeAtom = createAtomWithStorage<ProjectsViewMode>(
  'viewMode',
  ProjectsViewMode.Grid,
);

export const filterOptionAtom = createAtomWithStorage<ProjectsFilterOptions>(
  'filterOption',
  ProjectsFilterOptions.All,
);
